import React from 'react'
import { Carousel } from 'react-responsive-carousel'
import styled from 'styled-components'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { atlTheme } from '../../atlTheme'

export const CarouselWrapper = styled.div`
  width: 100%;
  min-height: 40vw;
  max-height: 20vh;
  display: flex;
  overflow: hidden;
  margin: ${atlTheme.SpacingBase}px 0;
`

export const CarouselImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: ${atlTheme.ColorWhite};
`

export const CustomWebCarousel = styled(Carousel)`
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  div {
    height: 100%;
    display: flex;

    ul {
      display: flex;
      box-sizing: border-box;
      width: 100%;
      margin: 0;
      padding: 0;

      li > div {
        margin: 0 16px;
      }
    }

    button {
      z-index: 3;
    }
  }
`

interface CustomCarouselProps {
  images?: { id: number; image: { uri: string } }[]
}

export const CustomCarousel: React.FunctionComponent<CustomCarouselProps> = ({ images }) => {
  return (
    <CarouselWrapper>
      <CustomWebCarousel
        showArrows={true}
        showThumbs={false}
        showIndicators={false}
        showStatus={false}
        centerMode={true}
        centerSlidePercentage={90}
      >
        {images &&
          images.map(item => {
            return (
              <div key={item.id}>
                <CarouselImg src={item.image.uri} />
              </div>
            )
          })}
      </CustomWebCarousel>
    </CarouselWrapper>
  )
}
